<template>
  <div style="display: flex; flex-direction: column">
    <div
      style="
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        margin-left: 10px;
        margin-right: 10px;
      "
    >
      <div style="flex: 0 0 450px; display: flex; justify-content: flex-end">
        <v-combobox
          v-model="choosesites"
          color="orange"
          multiple
          dense
          clearable
          outlined
          :label="$t('_selectionner_des_sites_')"
          auto-select-first="exact"
          :items="listsite"
          style="width: 100%"
          @blur="checkgoodperiode"
        >
          <template v-slot:selection="{ item, index }">
            <span v-if="index === 0">{{ choosesites[0] }}</span>
            <span v-else-if="index === 1 && choosesites.length > 1">
              , (+{{ choosesites.length - 1 }} autres)
            </span>
          </template>
          <v-list-item slot="prepend-item" ripple @click="toggleSelectAll">
            <v-list-item-action>
              <v-icon :color="choosesAllSites ? 'indigo darken-4' : ''">
                {{ icon }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-title>{{ $t("_select_all_") }}</v-list-item-title>
          </v-list-item>
          <v-divider slot="prepend-item" class="mt-2" />
        </v-combobox>
      </div>

      <div
        style="
          flex: 0 0 245px;
          display: flex;
          justify-content: flex-start;
          margin-top: -13px;
          margin-left: 5px;
          margin-right: 40px;
        "
      >
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-combobox
              v-model="dateRange"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              @click="menu = true"
              @click:prepend="resetDate()"
            ></v-combobox>
          </template>
          <v-date-picker
            v-model="dates"
            scrollable
            range
            :allowed-dates="allowedDates"
            @input="updateDateRange"
            :min="'2016-01-01'"
            :max="maxDate"
          >
            <v-spacer></v-spacer>
            <v-btn text style="font-size: bold" @click="menu = false"
              >Annuler</v-btn
            >
            <v-btn text color="primary" @click="checkgoodperiode"
              >Rafraichir</v-btn
            >
          </v-date-picker>
        </v-menu>
      </div>
    </div>
    <div
      style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: -25px 15px 15px;
        margin-bottom: -10px;
      "
    >
      <div style="display: flex; align-items: center">
        <span style="margin-right: 10px; color: black; margin-top: -3px">{{
          $t("_evolution_parc_")
        }}</span>
        <v-switch
          :label="$t('_evolution_centrales_')"
          color="orange"
          v-model="evolutiontype"
        ></v-switch>
      </div>

      <span style="
          flex: 0 0 245px;
          display: flex;
          justify-content: flex-start;              
       
        " >
        <select v-model="timestep">
          <option
            v-for="timestepOption in timestepOptions"
            :value="timestepOption.value"
            :key="timestepOption.value"
          >
            {{ timestepOption.label }}
          </option>
        </select>
      </span>
    </div>
    <div style="margin-left: 15px; gap: 5px; margin-top: -15px">
      <v-radio-group v-model="radios" row>
        <v-radio :label="$t('_pr_')" value="pr" color="orange"></v-radio>
        <v-radio
          v-if="raw_var"
          :label="$t('_pertes_vs_modele_energie_')"
          value="pertes"
          color="orange"
        ></v-radio>
        <v-radio
          v-if="raw_var"
          :label="$t('_eac_')"
          value="eac"
          color="orange"
        ></v-radio>
        <!--  <v-radio :label="$t('_evolution_dc_')" value="dc" color="orange"></v-radio>-->
        <v-radio
          :label="$t('_disponibilite_')"
          value="disponibilite"
          color="orange"
        ></v-radio>
        <v-radio
          v-if="raw_var"
          :label="$t('_actionable_losses_')"
          value="actionable"
          color="orange"
        ></v-radio>
      </v-radio-group>
    </div>
    <div>
      <v-card elevation="0">
        <plotly
          :key="`${change_size ? 'small' : 'large'}-${graph_key}`"
          ref="graph"
          :data="graph_data['data_render']"
          :layout="graph_data['layout_render']"
          :displayModeBar="true"
        />
        <LoadingDialog v-if="loading" :is_loading="loading" />
        <v-alert v-if="showNoDataAlert" type="warning" dense text class="mt-3">
          {{ $t("_donnees_manquantes_") }}
        </v-alert>
      </v-card>
    </div>
    <!-- <v-btn style="margin: 10px; margin-top: 10px; width: 300px;">{{ $t("_telecharger_le_tableau_comparatif_") }}</v-btn>-->
    <p></p>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import api from "@/api/api";
import { Plotly } from "vue-plotly";
import LoadingDialog from "@/components/Utils/LoadingDialog";

export default {
  components: {
    Plotly,
    LoadingDialog,
  },
  props: {
    selected_site_id: {
      type: Array,
      required: true,
    },

    change_size: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    const today = new Date();
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(today.getFullYear() - 1);
    const storeddates = JSON.parse(localStorage.getItem("storeddates"));

    return {
      loading: false,
      menu: false,
      today,
      oneYearAgo,
      initialLoadDone: false,
      maxDate: new Date(Date.now() - 86400000).toISOString().substr(0, 10),
      dates: storeddates || [
        oneYearAgo.toISOString().slice(0, 10),
        today.toISOString().slice(0, 10),
      ],
      dateRange: storeddates
        ? `${storeddates[0]} -> ${storeddates[1]}`
        : `${this.formatDate(oneYearAgo)} -> ${this.formatDate(today)}`,
      radios: localStorage.getItem("storedradios") || "pr",
      count: 0,
      listsite: [],
      evolution: [],
      timestep: "monthly",
      showNoDataAlert: false,
      label_y_axis: "_evolutions_",
      evolutiontype: false,
      raw_var: true,
      graph_key: 0,
      graph_data: {
        data_render: [],
        layout_render: {
          title: {
            text: "Evolution DC centrale Alexandre I",
            x: 0.1,
          },
          yaxis: {
            title: this.$t("_evolutions_"),
            position: 0,
            autorange: "true",
            rangemode: "tozero",
          },
          margin: {
            l: 70,
            r: 40,
            b: 60,
            t: 50,
          },
        },
      },
    };
  },

  mounted() {
    this.initializeSelection();

    // Only set choosesites if Vuex store is empty
    if (!this.choosesites || this.choosesites.length === 0) {
      this.choosesites = this.listsite;
    }

    this.refreshDates();
    this.change_title();
    this.extract_data_graph();
  },

  watch: {
    //   choosesites(newChoosesites) {
    //   // Recalculate total when choosesites changes
    //   this.total = newChoosesites.length - 1;
    // },
    radios(newRadios) {
      localStorage.setItem("storedradios", newRadios);
      if (newRadios === "eac") {
        this.label_y_axis = "_evolutions_kwh_";
      } else {
        this.label_y_axis = "_evolutions_%_";
      }
      this.extract_data_graph();
      this.change_title();
      this.graph_data.layout_render.yaxis.title = this.$t(this.label_y_axis);
    },
    evolutiontype: {
      handler() {
        this.extract_data_graph();
        this.change_title();
      },
    },
    timestep: {
      handler(newTimestep) {
        this.refreshDates();
        if (newTimestep === "raw" || newTimestep === "hourly") {
          this.raw_var = false;
        } else {
          this.raw_var = true;
        }
      },
    },
    installations(newVal) {
      if (newVal.length > 0) {
        this.initializeSelection(); // Re-run when installations data is available
      }
    },
    selected_site_id(newVal) {
      if (newVal.length > 0) {
        this.initializeSelection(); // Re-run when selected_site_id changes
        if (this.choosesites.length > 0) {
          this.total = this.choosesites.length - 1;
        }
      }
    },
  },

  computed: {
    ...mapGetters(["role", "installations", "cur_install_id", "constants"]),

    choosesites: {
      get() {
        return (
          this.$store.getters["selectedSitesStore/selectedSitesFleet"] || []
        );
      },
      set(val) {
        // Commit via namespaced mutation
        this.$store.commit("selectedSitesStore/SET_SELECTED_SITES_FLEET", val);
      },
    },

    total() {
      return this.choosesites.length > 1 ? this.choosesites.length - 1 : 0;
    },
    choosesAllSites() {
      return this.choosesites.length === this.listsite.length;
    },

    choosesSomeSites() {
      return this.choosesites.length > 0 && !this.choosesAllSites;
    },

    icon() {
      if (this.choosesAllSites) return "mdi-close-box";
      if (this.choosesSomeSites) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },

    formattedDates: {
      get() {
        return this.dates;
      },
      set(newdates) {
        if (!newdates[1]) {
          this.dates = [newdates[0], newdates[0]];
        } else {
          this.dates = newdates;
        }
      },
    },

    timestepOptions() {
      // const diffTime = Math.abs(
      //   new Date(this.dates[0]) - new Date(this.dates[1])
      // );
      // const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      return [
        // {
        //   label: this.$t("_donnees_brutes_"),
        //   value: "raw",
        //   active: diffDays <= 7,
        // },
        // {
        //   label: this.$t("_heure_"),
        //   value: "hourly",
        //   active: diffDays <= 30,
        // },
        {
          label: this.$t("_journee_"),
          value: "daily",
          active: true,
        },
        {
          label: this.$t("_semaine_"),
          value: "weekly",
          active: true,
        },
        {
          label: this.$t("_mois_"),
          value: "monthly",
          active: true,
        },
        {
          label: this.$t("_annee_"),
          value: "yearly",
          active: true,
        },
      ].filter((t) => t.active);
    },
  },

  methods: {
    async waitForData() {
      // Wait until installations and selected_site_id are populated
      while (
        !this.installations ||
        this.installations.length === 0 ||
        !this.selected_site_id ||
        this.selected_site_id.length === 0
      ) {
        await new Promise((resolve) => setTimeout(resolve, 100)); // wait 100ms
      }
    },
    resetDate() {
      this.dates = [
        this.oneYearAgo.toISOString().slice(0, 10),
        this.today.toISOString().slice(0, 10),
      ];
      this.updateDateRange();
    },

    allowedDates(date) {
      return date <= this.maxDate && date >= "2016-01-01";
    },

    checkgoodperiode() {
      if (this.dates[1] == null) {
        this.dates[1] = this.dates[0];
      }
      const diffTime = Math.abs(
        new Date(this.dates[0]) - new Date(this.dates[1])
      );
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

      if (this.timestep == "hourly" && this.dates[0] != this.dates[1]) {
        if (diffDays <= 30) {
          this.refreshDates();
        } else {
          this.timestep = "daily";
          this.refreshDates();
        }
      } else if (this.timestep == "raw" && this.dates[0] != this.dates[1]) {
        if (diffDays <= 7) {
          this.refreshDates();
        } else if (diffDays > 7 && diffDays <= 30) {
          this.timestep = "hourly";
          this.refreshDates();
        } else {
          this.timestep = "daily";
          this.refreshDates();
        }
      } else {
        this.refreshDates();
      }
    },

    change_title() {
      if (this.radios == "pr" && this.evolutiontype == true) {
        this.graph_data.layout_render.title.text = this.$t(
          "_evolutions_pr_centrales_"
        );
      } else if (this.radios == "pertes" && this.evolutiontype == true) {
        this.graph_data.layout_render.title.text = this.$t(
          "_evolutions_pertes_centrales_"
        );
      } else if (this.radios == "eac" && this.evolutiontype == true) {
        this.graph_data.layout_render.title.text = this.$t("_eac_");
      } else if (this.radios == "actionable" && this.evolutiontype == true) {
        this.graph_data.layout_render.title.text = this.$t(
          "_evolutions_actionable_centrales_"
        );
      } else if (this.radios == "dc" && this.evolutiontype == true) {
        this.graph_data.layout_render.title.text = this.$t(
          "_evolutions_dc_centrales_"
        );
      } else if (this.radios == "disponibilite" && this.evolutiontype == true) {
        this.graph_data.layout_render.title.text = this.$t(
          "_evolutions_disponibilite_centrales_"
        );
      } else if (this.radios == "pertes" && this.evolutiontype == false) {
        this.graph_data.layout_render.title.text = this.$t(
          "_evolution_pertes_parc_"
        );
      } else if (this.radios == "actionable" && this.evolutiontype == false) {
        this.graph_data.layout_render.title.text = this.$t(
          "_evolution_actionable_parc_"
        );
      } else if (this.radios == "dc" && this.evolutiontype == false) {
        this.graph_data.layout_render.title.text = this.$t(
          "_evolution_dc_parc_"
        );
      } else if (
        this.radios == "disponibilite" &&
        this.evolutiontype == false
      ) {
        this.graph_data.layout_render.title.text = this.$t(
          "_evolution_disponibilite_parc_"
        );
      } else if (this.radios == "pr" && this.evolutiontype == false) {
        this.graph_data.layout_render.title.text = this.$t(
          "_evolution_pr_parc_"
        );
      } else if (this.radios == "eac" && this.evolutiontype == false) {
        this.graph_data.layout_render.title.text = this.$t(
          "_evolution_eac_parc_"
        );
      }
    },

    initializeSelection() {
      const nameSet = new Set();

      if (this.installations.length > 0) {
        this.selected_site_id.forEach((element) => {
          this.installations.forEach((site) => {
            if (element === site.installation_id.toString()) {
              nameSet.add(site.installation_name.trim());
            }
          });
        });
      }

      this.listsite = [...nameSet];
      
      if (!this.choosesites || this.choosesites.length === 0) {
        this.choosesites = [...this.listsite];
      }
    },

    formatDate(date) {
      return date.toISOString().slice(0, 10);
    },

    updateDateRange() {
      if (this.dates && this.dates.length > 0) {
        if (!this.dates[1]) {
          this.dateRange = `${this.dates[0]} -> ${this.dates[0]}`;
        } else {
          let [startDate, endDate] = this.dates.sort(
            (a, b) => new Date(a) - new Date(b)
          );
          this.dateRange = `${startDate} -> ${endDate}`;
        }
      } else {
        this.dateRange = "";
      }
    },

    take_id() {
      let list_id = [];
      this.installations.forEach((element) => {
        if (this.choosesites.includes(element.installation_name)) {
          list_id.push(element.installation_id.toString());
        }
      });
      this.total = 0;
      this.total = this.choosesites.length - 1;
      return list_id;
    },

    changeidbyname(person) {
      let name = "";

      this.installations.forEach((element) => {
        if (element.installation_id == person) {
          name = element.installation_name;
        }
      });

      return name;
    },

    async refreshDates() {
      this.menu = false;
      if (this.count != 0) {
        this.loading = true;
      }
      this.count++;
      try {
        const response = await api.getgraphfleetevolution({
          dates: this.dates,
          choosesite: this.take_id(),
          periode: this.timestep,
        });
        if (response && response.data) {
          this.evolution = response.data;

          // ✅ Check if there’s actual graph data
          if (!response.data || Object.keys(response.data).length === 0) {
            this.graph_data.data_render = [];

            // Change title
            this.graph_data.layout_render.title.text = this.$t("_donnees_manquantes_");
            // 🔹 Force Vue to re-render Plotly completely
            this.graph_key += 1;
            this.showNoDataAlert = true;
          } else {
            this.showNoDataAlert = false;
            await this.extract_data_graph();
          }

          localStorage.setItem("storeddates", JSON.stringify(this.dates));
          this.loading = false;
        }
      } catch (error) {
        this.showNoDataAlert = true;
      } finally {
        this.loading = false;
      }
    },

    toggleSelectAll() {
      if (this.choosesAllSites) {
        this.choosesites = [];
      } else {
        this.choosesites = this.listsite;
      }
    },

    extract_data_graph() {
      let info = [];
      this.graph_data.data_render = [];

      if (this.radios == "pr" && this.evolutiontype == true) {
        info = this.evolution.pr;
      } else if (this.radios == "pertes" && this.evolutiontype == true) {
        info = this.evolution.pertes;
      } else if (this.radios == "actionable" && this.evolutiontype == true) {
        info = this.evolution.actionable;
      } else if (this.radios == "dc" && this.evolutiontype == true) {
        info = this.evolution.dc;
      } else if (this.radios == "disponibilite" && this.evolutiontype == true) {
        info = this.evolution.availability;
      } else if (this.radios == "pertes" && this.evolutiontype == false) {
        info = this.evolution.pertes_parc;
      } else if (this.radios == "actionable" && this.evolutiontype == false) {
        info = this.evolution.actionable_parc;
      } else if (this.radios == "dc" && this.evolutiontype == false) {
        info = this.evolution.dc_parc;
      } else if (
        this.radios == "disponibilite" &&
        this.evolutiontype == false
      ) {
        info = this.evolution.availability_parc;
      } else if (this.radios == "pr" && this.evolutiontype == false) {
        info = this.evolution.pr_parc;
      } else if (this.radios == "eac" && this.evolutiontype == true) {
        info = this.evolution.eac;
      } else if (this.radios == "eac" && this.evolutiontype == false) {
        info = this.evolution.eac_parc;
      }

      Object.entries(info).forEach(([person, values]) => {
        let render = {};
        if (this.radios != "eac") {
          if (this.evolutiontype == false) {
            render = {
              x: [],
              y: [],
              type: "line",
              name: person,
              hovertemplate: `<b>${person}</b><br>%{y}%<br>%{x|%d/%m/%Y %H:%M}<extra></extra>`,
            };
          } else {
            render = {
              x: [],
              y: [],
              type: "line",
              name: this.changeidbyname(person),
              hovertemplate: `<b>${this.changeidbyname(
                person
              )}</b><br>%{y}%<br><extra></extra>`,
            };
          }
        } else {
          if (this.evolutiontype == false) {
            render = {
              x: [],
              y: [],
              type: "line",
              name: person,
              hovertemplate: `<b>${person}</b><br>%{y}<br>%{x|%d/%m/%Y %H:%M}<extra></extra>`,
            };
          } else {
            render = {
              x: [],
              y: [],
              type: "line",
              name: this.changeidbyname(person),
              hovertemplate: `<b>${this.changeidbyname(
                person
              )}</b><br>%{y}<br><extra></extra>`,
            };
          }
        }
        Object.entries(values).forEach(([date, value]) => {
          render.x.push(date.replace(" ", "T")); // Or new Date(date).toISOString()
          render.y.push(value);
        });

        this.graph_data.data_render.push(render);
      });
      return info;
      //Object.entries(values).forEach(([date, value]) => {
      // let formattedDate = new Date(date).toLocaleDateString("fr-FR", {
      //   year: 'numeric',
      //   month: '2-digit',
      //   day: '2-digit',
      //   hour: '2-digit',
      //   minute: '2-digit',
      //   second: '2-digit'
      // });
      //render.x.push(date);
      //render.y.push(value);
      //});

      // this.graph_data.data_render.push(render);
      //});
      //return info;
    },
  },
};
</script>

<style>
select {
  background-color: #eef1f8;
  border-radius: 20px;
  border: none;
  padding-top: 4px;
  padding-bottom: 4px;
  height: 100%;
  max-width: 100%;
}
.v-menu__content {
  min-width: 290px !important;
}
.v-label {
  color: black !important;
}
</style>
